import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/mdx-import/",
          "title": "Import MDX from other files"
        }}>{`A snippet`}</MDXTag>{` demonstrating how to import markdown in other MDX or JS files. In MDX, import statements must be inserted in the beginning, right after the frontmatter`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`import Chart from 'content/snippets/main/chart'

........

<Chart/>
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Import MDX from other file",
  "keywords": "MDX, React, import",
  "menu": "mdx/import"
};
    